import api from "../../../utils/authFetch";

export const getUserProfile = async (userId) => {
    const response = await api.get(`${process.env.REACT_APP_BACKEND_URL}/prediction/admin/ai-users/${userId}`);
    const data = response.data;
    return data;
};


export const updateUserProfile = async (userId, data) => {
    const response = await api.patch(`${process.env.REACT_APP_BACKEND_URL}/prediction/admin/ai-users/${userId}`, data);
    return response.data;
};